import { useTheme } from '@mui/material'
import React from 'react'
import { BadgeText } from './BadgeText'

type CalendarDayIconProps = {
  day: number
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

export const CalendarDayIcon = ({ day, width = 20, height = 20, className, color }: CalendarDayIconProps) => {
  const theme = useTheme()
  const fillColor = color ?? theme.palette.secondary.main
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="7.29019" cy="12.8546" r="7.14371" fill={fillColor} />
      <path
        d="M14.1035 0C14.5177 3.29839e-05 14.8535 0.335807 14.8535 0.75V1.40527H17.6504C19.0311 1.40538 20.1503 2.52453 20.1504 3.90527V16.1572C20.1504 17.538 19.0312 18.6581 17.6504 18.6582H13.0195C13.4753 18.2081 13.8776 17.7048 14.2178 17.1582H17.6504C18.2028 17.1581 18.6504 16.7096 18.6504 16.1572V3.90527C18.6503 3.35295 18.2027 2.90538 17.6504 2.90527H14.8535V3.43848C14.8535 3.85267 14.5177 4.18844 14.1035 4.18848C13.6893 4.18845 13.3535 3.85267 13.3535 3.43848V2.90527H7.85254V3.43848C7.85254 3.8526 7.51663 4.18833 7.10254 4.18848C6.68833 4.18848 6.35254 3.85269 6.35254 3.43848V2.90527H4.47656C3.9243 2.90544 3.47664 3.35299 3.47656 3.90527V5.64746C2.9377 5.93312 2.43521 6.27744 1.97656 6.67188V3.90527C1.97664 2.52456 3.09587 1.40544 4.47656 1.40527H6.35254V0.75C6.35254 0.335786 6.68833 0 7.10254 0C7.51663 0.000142988 7.85254 0.335875 7.85254 0.75V1.40527H13.3535V0.75C13.3535 0.335806 13.6893 3.14378e-05 14.1035 0Z"
        fill={fillColor}
      />
      <path
        d="M16.0356 10.6641H14.9296L16.5676 6.63206H15.0416V7.52106H14.1526V5.77806H17.6106V6.68806L16.0356 10.6641Z"
        fill={fillColor}
      />
      <BadgeText x="7.29" y="12.85" fontSize="10" fill="white">
        {day}
      </BadgeText>
    </svg>
  )
}
